import { render, staticRenderFns } from "./modalClose.vue?vue&type=template&id=4b7fe18a&"
import script from "./modalClose.vue?vue&type=script&lang=js&"
export * from "./modalClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports